import { getWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
import { Product } from "./product";
import { Project } from "./project";
import { Building } from "./building";
import { Structure } from "./structure";
import { Supply_chain } from "./supply_chain";

const pending_validation = apiUrl + "/pending_validation";
const routes = {
  label: "Pending Validation",
  get_all: pending_validation + "/get_all",
};
export const PendingValidation = {
  label: routes.label,
  get_all: () => getWithToken(routes.get_all),
  set_validation_status: ({ id, product_id, project_id, building_id, organization_id, validation_status, record_type, sub_type, category_label }) => {
    console.log("Setting validation status", { id, product_id, project_id, building_id, validation_status, record_type, sub_type });
    const targetId = id || organization_id || product_id || project_id || building_id;
    switch (record_type) {
      case "product":
        return Product.set_validation_status({ id: product_id || id, validation_status });
      case "project":
        return Project.set_validation_status({ id: project_id || id, validation_status });
      case "building":
        return Building.set_validation_status({ id: building_id || id, validation_status });
      case "structure":
        return Structure.set_validation_status({ id: targetId, validation_status });
      case "supply_chain":
        return Supply_chain.set_validation_status({ id: targetId, validation_status });
      case "organization":
        if (sub_type === "supply_chain" || category_label === "Supply Chain") {
          return Supply_chain.set_validation_status({ id: targetId, validation_status });
        }
        return Structure.set_validation_status({ id: targetId, validation_status });
      default:
        return Structure.set_validation_status({ id: targetId, validation_status });
    }
  },
};
